export enum UserRole {
  ADMIN = 'ADMIN',
  TEACHER = 'TEACHER',
  STUDENT = 'STUDENT',
  UNKNOWN = 'UNKNOWN',
}

export interface UserProfile {
  role: UserRole;
  first_name: string;
  last_name: string;
  full_name: string;
  dob: string;
  auth_uid?: string;
  user_token?: string;
  username: string;
  email: string;
  phone?: string;
  password?: string;
  created_at: string;
  deleted: boolean;
}

export type UserProfileForm = Pick<
  UserProfile,
  'first_name' | 'last_name' | 'email' | 'dob'
>;

export interface IUserRoleResponse extends UserProfile {
  isLogin: boolean;
  error: string;
}
